import axios from 'axios';
import getAuthToken from '../utils/cookie';

export const sendTemplateFile = async (data) => {
  const formData = new FormData();
  for (const key in data) {
    formData.append(key, data[key]);
  }

  const tok = getAuthToken();
  try {
    const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}custom_template/`, formData, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${tok}`
      }
    });
    return {
      status: res.status,
      data: res.data
    };
  } catch (err) {
    return {
      status: err?.response?.status || 500,
      message: err?.response?.data?.message || 'Something went wrong'
    };
  }
};

export const getDefaultLanguage = async () => {
  const token = getAuthToken();
  try {
    const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}default_language/`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return res;
  } catch (err) {
    throw err;
  }
};

export const updateDefaultLanguage = async (languageCode) => {
  const tok = getAuthToken();
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}default_language/update/`,
      { language_code: languageCode },
      {
        headers: {
          Authorization: `Bearer ${tok}`
        }
      }
    );
    return res;
  } catch (err) {
    throw err;
  }
};